
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.462 3.726a.334.334 0 00-.361.071l-.853.847a4.66 4.66 0 10.812 5.688.393.393 0 00-.146-.539.4.4 0 00-.542.144 3.886 3.886 0 11-.684-4.736l-.985.979a.327.327 0 00-.072.358.332.332 0 00.306.2h2.4a.329.329 0 00.331-.329V4.034a.328.328 0 00-.206-.308z"}})])
          )
        }
      }
    